import { ApplicationConfig, importProvidersFrom } from '@angular/core';

import {provideRouter, withHashLocation} from '@angular/router';

import { routes } from './app.routes';
import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from '@services/security/http.interceptor';
import { errorInterceptor } from '@services/security/error.interceptor';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),

    importProvidersFrom(
      HttpClientModule,
      BrowserAnimationsModule
    ),

    provideHttpClient(withInterceptors([
      httpInterceptor,
      errorInterceptor
    ]))

  ]
};
